import store from '@/store';

export default {
	async optOut(parent, clusterId, notifyZone) {
		try {
			await parent.$confirm(
				'Are you sure you want to opt out the shared cluster? You would need to request access again',
				'Confirmation',
				'warning',
				{
					confirmButtonText: 'Yes',
					cancelButtonText: 'No',
				},
			);
		} catch { return }

		try {
			let response
			response = await store.dispatch('optOutSharedClusterMiddleware', {
							clusterId: clusterId
						});
			if (response.success) {
				await parent.updateShowedElements(true, '')
				const successText = response.message
				const successTitle = 'CLUSTER OPTING MANAGEMENT'
				parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.SUCCESS, successTitle, successText, notifyZone)
			}
			else {
				await this.$alert(
					`Error opting out: ${response.message}`,
					'Operation Failed',
					'error',
				)
			}
		} catch {
			await this.$alert(
				'Something went wrong in middle of the process',
				'Operation Failed',
				'error',
			)
		}finally{
			parent.isLoading = false;
		}
	}
}
